export default {
    namespaced: true,
    state: {
        // 远程中的集合
        remotingArr: [],
        // 是否已经安装插件
        isInstalled:false,
        // 是否需要更新插件
        needUpdate:false
    },
    getters: {
        // 正在远程中的flag集合
        remotingFlagArr: (state) => {
            let arr = []
            state.remotingArr.forEach(item => {
                arr.push(item.flag)
            })
            return arr
        }
    },
    mutations: {
        setRemotingArr(state,arr){
            state.remotingArr=arr
        },
        setIsInstalled(state,bool){
            state.isInstalled=bool
        },
        setNeedUpdate(state,bool){
            state.needUpdate=bool
        }
    },
    actions: {
        actionSetRemotingArr({
            commit
        },arr){
            commit('setRemotingArr',arr)
        },
        actionSetIsInstalled({
            commit
        },bool){
            commit('setIsInstalled',bool)
        },
        actionSetNeedUpdate({
            commit
        },bool){
            commit('setNeedUpdate',bool)
        }
    }
}